export default __webpack_public_path__ + "static/media/contactsYellow.85ae6023.svg";